module.exports = __webpack_public_path__ + "img/HomeOutlined.12b8b3fd.svg";